import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function UrbaniaHireInShrirdi() {



    const cardData = {




keyword: "Urbania Hire in Shirdi",
headingDescription: "Sai Shirdi Cab offers reliable Urbania hire in Shirdi for families, friends, corporate teams, pilgrimage groups, wedding parties, school and college groups, and other large travel groups. Our Urbania hire service is designed for comfortable group transportation across local and outstation routes, including airport transfers, sightseeing tours, religious journeys, corporate travel, weddings, one-way trips, round trips, and multi-day tours. Hiring a dedicated Urbania allows your entire group to travel together with convenient seating, luggage space, and better coordination throughout the journey. Customers can plan their trip according to their preferred pickup point, destination, travel date, passenger requirement, and duration. Whether you need an Urbania for a short Shirdi trip or a longer outstation journey, Sai Shirdi Cab provides a practical group travel solution with flexible trip planning.",
topPlaces: [
{
title: "Goa",
description: "Hire an Urbania in Shirdi for a comfortable group journey to Goa with family, friends, or a travel group. Sai Shirdi Cab provides a convenient option for long-distance holiday travel, allowing passengers to remain together throughout the route with suitable space for luggage and travel essentials."
},
{
title: "Mumbai",
description: "Urbania hire in Shirdi is a practical choice for groups travelling to Mumbai for business visits, family functions, events, airport transfers, or sightseeing. A dedicated vehicle helps everyone travel together without the need to coordinate multiple cars, making the overall journey easier to manage."
},
{
title: "Pune",
description: "Book an Urbania from Shirdi for group travel to Pune, whether you are planning a corporate trip, family visit, educational tour, or social event. Sai Shirdi Cab can arrange group transportation according to your schedule, pickup location, passenger count, and preferred journey plan."
},
{
title: "Mahabaleshwar",
description: "Plan a relaxing group trip from Shirdi to Mahabaleshwar by hiring an Urbania for your family or friends. The spacious group vehicle is well suited for weekend holidays, sightseeing programs, and extended trips where passengers want to travel together while carrying luggage and personal belongings conveniently."
},
{
title: "Ujjain",
description: "Hire an Urbania in Shirdi for a pilgrimage or multi-day journey to Ujjain with devotees, families, or organized groups. Sai Shirdi Cab offers dedicated group transportation that makes route planning and passenger coordination easier for longer outstation journeys and religious travel."
},
{
title: "Nashik",
description: "An Urbania hire from Shirdi to Nashik works well for families, pilgrimage groups, corporate teams, and sightseeing groups. Passengers can enjoy the convenience of travelling together while planning stops and return travel according to their itinerary, making the vehicle suitable for both direct and round-trip journeys."
},
{
title: "Bhimashankar",
description: "Choose an Urbania for a group pilgrimage from Shirdi to Bhimashankar when travelling with family members, friends, or devotees. Sai Shirdi Cab provides a convenient dedicated vehicle for the journey, helping groups stay together and manage luggage comfortably during the trip."
},
{
title: "Chhatrapati Sambhajinagar",
description: "Urbania hire from Shirdi to Chhatrapati Sambhajinagar is suitable for sightseeing groups, family tours, religious journeys, and business travel. With one dedicated vehicle for the group, passengers can coordinate the complete journey more easily while travelling with their luggage and planned stops."
},
{
title: "Trimbakeshwar",
description: "Travel from Shirdi to Trimbakeshwar by hiring an Urbania for a comfortable group pilgrimage or sightseeing trip. The service is suitable for devotees and families who prefer travelling together in one spacious vehicle, with flexible planning for pickup, destination, return journey, and additional stops."
},
{
title: "Ahmednagar",
description: "Hire an Urbania in Shirdi for group travel to Ahmednagar for business visits, family occasions, religious programs, or local and outstation requirements. Sai Shirdi Cab can help arrange transportation around your passenger count and schedule, providing a convenient alternative to booking several smaller vehicles."
}
]
,







"services": [
{
"name": "Urbania Hire in Shirdi",
"description": "Urbania Hire in Shirdi from Sai Shirdi Cabs provides spacious and comfortable group transportation for families, tourists, corporate teams, and pilgrimage travelers. With professional driver support and flexible travel arrangements, the service is suitable for local sightseeing, special occasions, airport transfers, and outstation journeys."
},
{
"name": "Urbania Rental in Shirdi",
"description": "Urbania Rental in Shirdi offers a convenient travel option for groups who want to travel together in a comfortable and spacious vehicle. Sai Shirdi Cabs provides Urbania rental services for family trips, religious tours, corporate travel, weddings, sightseeing, and long-distance journeys."
},
{
"name": "Force Urbania Hire Shirdi",
"description": "Force Urbania Hire Shirdi is suitable for larger groups looking for comfortable transportation with convenient driver assistance. Sai Shirdi Cabs offers well-maintained Urbania vehicles for pilgrimage tours, family vacations, corporate outings, wedding functions, airport transfers, and outstation travel."
},
{
"name": "Urbania on Rent Shirdi",
"description": "Urbania on Rent Shirdi from Sai Shirdi Cabs provides spacious transportation for groups planning local or outstation travel. The service is useful for sightseeing, family tours, pilgrimage journeys, business trips, special events, and multi-day road travel with comfortable seating and professional support."
},
{
"name": "Urbania Booking Shirdi",
"description": "Urbania Booking Shirdi makes it easy to arrange group transportation according to your preferred route and travel schedule. Sai Shirdi Cabs provides Urbania booking for family outings, pilgrimage trips, corporate journeys, weddings, sightseeing tours, airport transfers, and outstation destinations."
},
{
"name": "Urbania with Driver Shirdi",
"description": "Urbania with Driver Shirdi is a convenient choice for passengers who want to enjoy their journey without handling the driving themselves. Sai Shirdi Cabs provides experienced drivers with spacious Urbania vehicles for local travel, sightseeing, pilgrimage routes, family trips, and longer outstation journeys."
},
{
"name": "Urbania Cab Hire Shirdi",
"description": "Urbania Cab Hire Shirdi offers comfortable group transportation when a regular cab does not provide enough space for everyone. Sai Shirdi Cabs arranges Urbania vehicles for families, tourists, corporate groups, wedding parties, and pilgrims traveling within Shirdi or to destinations outside the city."
},
{
"name": "Urbania Taxi Hire Shirdi",
"description": "Urbania Taxi Hire Shirdi provides spacious and dependable transportation for groups traveling together. With Sai Shirdi Cabs, customers can arrange Urbania taxi services for airport transfers, railway station pickups, sightseeing, family holidays, pilgrimage tours, corporate travel, and outstation trips."
},
{
"name": "Urbania for Outstation Shirdi",
"description": "Urbania for Outstation Shirdi is an ideal option for groups traveling from Shirdi to nearby cities, tourist destinations, pilgrimage centers, and major airports. Sai Shirdi Cabs offers spacious vehicles with professional drivers, making long-distance group journeys more convenient and comfortable."
},
{
"name": "Urbania for Family Trip Shirdi",
"description": "Urbania for Family Trip Shirdi allows families to travel together in one spacious vehicle instead of arranging multiple cars. Sai Shirdi Cabs provides comfortable Urbania transportation for vacations, weekend getaways, temple visits, sightseeing tours, family functions, and multi-destination road trips."
},
{
"name": "Urbania for Wedding Shirdi",
"description": "Urbania for Wedding Shirdi is a practical transportation solution for wedding guests, relatives, and event groups. Sai Shirdi Cabs can arrange comfortable Urbania vehicles for hotel transfers, venue travel, airport pickups, railway station transfers, and wedding-related outstation journeys."
},
{
"name": "Urbania for Corporate Trip Shirdi",
"description": "Urbania for Corporate Trip Shirdi provides comfortable group transportation for employees, business teams, meetings, conferences, and company outings. Sai Shirdi Cabs offers driver-assisted Urbania travel for corporate requirements, helping teams travel together conveniently for local and outstation business trips."
},
{
"name": "Urbania for Pilgrimage Shirdi",
"description": "Urbania for Pilgrimage Shirdi is designed for families and religious groups visiting temples and spiritual destinations from Shirdi. Sai Shirdi Cabs provides spacious Urbania vehicles for pilgrimage tours, multi-temple journeys, and religious trips where comfortable group transportation is important."
},
{
"name": "Urbania for Tour Shirdi",
"description": "Urbania for Tour Shirdi offers a convenient way for groups to explore tourist attractions and destinations around Shirdi and beyond. Sai Shirdi Cabs provides spacious Urbania transportation for sightseeing holidays, weekend tours, hill-station trips, cultural journeys, and multi-city travel plans."
},
{
"name": "Urbania One Way Hire Shirdi",
"description": "Urbania One Way Hire Shirdi is suitable for groups traveling from Shirdi to another destination without requiring the same vehicle for the return journey. Sai Shirdi Cabs provides comfortable one-way Urbania travel for airport transfers, business trips, family journeys, pilgrimage routes, and outstation transportation."
},
{
"name": "Urbania Round Trip Hire Shirdi",
"description": "Urbania Round Trip Hire Shirdi is a convenient choice for families and groups planning return travel, sightseeing tours, pilgrimage trips, and multi-day vacations. Sai Shirdi Cabs provides spacious Urbania vehicles with driver support, allowing passengers to follow their planned itinerary and return comfortably to Shirdi."
},
{
"name": "Urbania Airport Pickup Shirdi",
"description": "Urbania Airport Pickup Shirdi provides spacious group transportation for passengers arriving at nearby airports and continuing their journey to Shirdi. Sai Shirdi Cabs offers comfortable Urbania vehicles with room for passengers and luggage, making airport-to-Shirdi transfers convenient for families and groups."
},
{
"name": "Urbania Railway Station Pickup Shirdi",
"description": "Urbania Railway Station Pickup Shirdi is a convenient service for groups arriving at Shirdi railway stations and requiring onward transportation. Sai Shirdi Cabs can arrange spacious Urbania vehicles for family pickups, pilgrimage groups, hotel transfers, tourist travel, and onward outstation journeys."
},
{
"name": "Luxury Urbania Hire Shirdi",
"description": "Luxury Urbania Hire Shirdi provides a premium and spacious travel experience for groups who value comfort during their journey. Sai Shirdi Cabs offers luxury Urbania transportation for family vacations, corporate trips, pilgrimage tours, weddings, sightseeing, airport transfers, and long-distance travel."
},
{
"name": "Affordable Urbania Hire Shirdi",
"description": "Affordable Urbania Hire Shirdi from Sai Shirdi Cabs offers a budget-friendly group transportation option with spacious seating and convenient travel support. It is suitable for families, tourists, pilgrimage groups, corporate teams, wedding parties, sightseeing travelers, and passengers planning outstation journeys."
},
{
"name": "Sai Shirdi Cabs",
"description": "Sai Shirdi Cabs provides reliable Urbania hire, rental, booking, airport pickup, railway station pickup, sightseeing, pilgrimage, family, corporate, wedding, and outstation transportation services in Shirdi. Our spacious Urbania vehicles and professional drivers are suitable for comfortable group travel across different routes and destinations."
}
],
"tableData": [
["Urbania Hire in Shirdi", "Urbania Rental in Shirdi"],
["Force Urbania Hire Shirdi", "Urbania on Rent Shirdi"],
["Urbania Booking Shirdi", "Urbania with Driver Shirdi"],
["Urbania Cab Hire Shirdi", "Urbania Taxi Hire Shirdi"],
["Urbania for Outstation Shirdi", "Urbania for Family Trip Shirdi"],
["Urbania for Wedding Shirdi", "Urbania for Corporate Trip Shirdi"],
["Urbania for Pilgrimage Shirdi", "Urbania for Tour Shirdi"],
["Urbania One Way Hire Shirdi", "Urbania Round Trip Hire Shirdi"],
["Urbania Airport Pickup Shirdi", "Urbania Railway Station Pickup Shirdi"],
["Luxury Urbania Hire Shirdi", "Affordable Urbania Hire Shirdi"],
["Sai Shirdi Cabs", "Urbania Hire in Shirdi"]
]
,





whychoose: [  
 
    {   
 
        WhyChooseheading: "Urbania Hire in Shirdi for Group Travel",   
 
        WhyChoosedescription: "Sai Shirdi Cabs offers Urbania Hire in Shirdi for families, pilgrimage groups, tourists, corporate teams, wedding guests, and other groups travelling together. Urbania can be hired for local sightseeing, temple visits, airport and railway station transfers, family functions, corporate travel, outstation journeys, and multi-day road trips based on your planned itinerary."   
 
    },   
 
    {   
 
        WhyChooseheading: "Comfortable Urbania Hire Service in Shirdi",   
 
        WhyChoosedescription: "Hiring a dedicated Urbania allows groups to travel together without coordinating multiple cars during the journey. Sai Shirdi Cabs can arrange the vehicle according to your passenger count, luggage requirements, pickup location, destination, travel date, preferred departure time, and overall trip schedule for convenient group transportation."   
 
    },   
 
    {   
 
        WhyChooseheading: "Urbania Hire for Shirdi Sightseeing",   
 
        WhyChoosedescription: "Tourists and visiting families can hire an Urbania in Shirdi for planned local sightseeing and nearby attractions. Your group can travel together between selected sightseeing points, hotels, temples, restaurants, and other locations while keeping the journey organized according to your preferred route, visiting schedule, and available travel time."   
 
    },   
 
    {   
 
        WhyChooseheading: "Urbania Hire for Shirdi Pilgrimage Tours",   
 
        WhyChoosedescription: "Pilgrimage groups can arrange Urbania Hire in Shirdi for temple visits, Darshan travel, religious tours, and journeys to nearby spiritual destinations. Sai Shirdi Cabs can coordinate transportation around your group's travel dates, pickup points, passenger requirements, luggage needs, planned stops, and complete pilgrimage itinerary."   
 
    },   
 
    {   
 
        WhyChooseheading: "Urbania Hire for Outstation Trips from Shirdi",   
 
        WhyChoosedescription: "Groups planning road trips from Shirdi can hire an Urbania for selected outstation cities, tourist destinations, pilgrimage locations, and multi-destination routes. One-way, round-trip, and multi-day arrangements can be discussed according to the destination, route, number of passengers, luggage, sightseeing plans, and duration of the journey."   
 
    },   
 
    {   
 
        WhyChooseheading: "Urbania for Family and Corporate Group Travel",   
 
        WhyChoosedescription: "Sai Shirdi Cabs provides Urbania hire options for family vacations, group outings, corporate meetings, employee travel, school and college groups, social events, and organized tours. Travelling together in one vehicle makes it easier to coordinate departure times, luggage, breaks, sightseeing stops, hotel transfers, and scheduled activities."   
 
    },   
 
    {   
 
        WhyChooseheading: "Urbania Hire for Airport and Railway Transfers",   
 
        WhyChoosedescription: "Groups arriving in or departing from Shirdi can hire an Urbania for coordinated airport and railway station transfers. The service can be planned around your arrival or departure timing, passenger count, luggage requirements, pickup location, destination, and onward travel schedule so that the group can manage the transfer together."   
 
    },   
 
    {   
 
        WhyChooseheading: "Book Urbania Hire in Shirdi",   
 
        WhyChoosedescription: "To arrange Urbania Hire in Shirdi, contact Sai Shirdi Cabs with your travel date, pickup location, destination, passenger count, luggage details, preferred departure time, journey type, and expected rental duration. Complete trip information helps in planning suitable Urbania transportation for sightseeing, pilgrimage travel, family tours, airport transfers, railway transfers, events, and outstation journeys."   
 
    }   
 
]   
 
 
}; 
 
const faqData = [ 
 
{ 
 
question: "Can I hire an Urbania in Shirdi?", 
 
answer: "Yes, Sai Shirdi Cabs provides Urbania hire services in Shirdi for families, tourists, pilgrimage groups, corporate teams, events, and other group travel requirements." 
 
}, 
 
{ 
 
question: "What can I use an Urbania Hire in Shirdi for?", 
 
answer: "Urbania can be hired for local sightseeing, pilgrimage tours, family trips, corporate travel, airport transfers, railway station transfers, events, and outstation journeys." 
 
}, 
 
{ 
 
question: "Can I hire an Urbania for Shirdi sightseeing?", 
 
answer: "Yes, an Urbania can be hired for Shirdi sightseeing and nearby attractions according to your selected locations, passenger count, pickup point, travel schedule, and sightseeing requirements." 
 
}, 
 
{ 
 
question: "Is Urbania available for pilgrimage travel from Shirdi?", 
 
answer: "Yes, you can hire an Urbania from Shirdi for temple visits, Darshan travel, religious tours, and multi-destination pilgrimage journeys based on your planned itinerary." 
 
}, 
 
{ 
 
question: "Can I hire an Urbania from Shirdi for an outstation trip?", 
 
answer: "Yes, Urbania hire can be arranged from Shirdi for outstation travel through one-way, round-trip, or multi-day arrangements depending on your destination and journey plan." 
 
}, 
 
{ 
 
question: "Is Urbania suitable for family group travel in Shirdi?", 
 
answer: "Yes, families can hire an Urbania for vacations, sightseeing, pilgrimage trips, family functions, airport transfers, railway transfers, and longer road journeys." 
 
}, 
 
{ 
 
question: "Can corporate groups hire an Urbania in Shirdi?", 
 
answer: "Yes, corporate teams can hire an Urbania for business travel, meetings, events, employee transportation, airport transfers, and planned group movements from Shirdi." 
 
}, 
 
{ 
 
question: "Can I travel with luggage in a hired Urbania?", 
 
answer: "Yes, luggage can be carried during the journey, and providing the passenger count along with approximate luggage requirements helps in planning the suitable vehicle arrangement." 
 
}, 
 
{ 
 
question: "Can I hire an Urbania in Shirdi for multiple days?", 
 
answer: "Yes, multi-day Urbania hire can be discussed for family vacations, pilgrimage tours, sightseeing trips, group events, and multi-destination road journeys according to your itinerary." 
 
}, 
 
{ 
 
question: "How can I book Urbania Hire in Shirdi?", 
 
answer: "You can contact Sai Shirdi Cabs with your travel date, pickup location, passenger count, destination, luggage details, journey type, preferred departure time, and rental duration to arrange an Urbania." 
 
} 
 
]; 
 
const testimonials = [ 
 
{ 
 
id: 1, 
 
name: "Mr. Rahul Deshmukh", 
 
feedback: "Our experience with the Urbania during a group pilgrimage from Shirdi was convenient from the start. Everyone could travel together with the luggage, and managing temple visits, meal breaks, hotel transfers, and the planned route was much easier than arranging separate cars.", 
 
rating: 5 
 
}, 
 
{ 
 
id: 2, 
 
name: "Mrs. Neha Kulkarni", 
 
feedback: "The private Urbania worked well for our family sightseeing trip around Shirdi. We had enough flexibility to follow our planned schedule, make sightseeing stops, and move between different locations together without having to coordinate several vehicles.", 
 
rating: 5 
 
} 
 
];

    const Images = [
        { place: "/images/keyword/1.jpg", text: "Nagarsol to Shirdi Cab", link: "Nagarsol-to-Shirdi-Cab" },
        { place: "/images/keyword/2.jpg", text: "Shirdi Cab Service", link: "Shirdi-Cab-Service" },
        { place: "/images/keyword/3.jpg", text: "Shirdi to Shani Shingnapur Cab", link: "Shirdi-to-Shani-Shingnapur-Cab" },
        { place: "/images/keyword/4.jpg", text: "Shirdi to Grishneshwar Cab", link: "Shirdi-to-Grishneshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Shirdi to Manmad Cab", link: "Shirdi-to-Manmad-Cab" },
        { place: "/images/keyword/6.jpg", text: "Shirdi to Lonavala Cab", link: "Shirdi-to-Lonavala-Cab" },
        { place: "/images/keyword/7.jpg", text: "Shirdi to Mahabaleshwar Cab", link: "Shirdi-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/8.jpg", text: "Shirdi to Ashtavinayak Darshan Package", link: "Shirdi-to-Ashtavinayak-Darshan-Package" },
        { place: "/images/keyword/9.jpg", text: "Shirdi to Saptashrungi Cab", link: "Shirdi-to-Saptashrungi-Cab" },
        { place: "/images/keyword/10.jpg", text: "Shirdi Tour Package", link: "Shirdi-Tour-Package" },
        { place: "/images/keyword/11.jpg", text: "Best Taxi Service in Shirdi", link: "Best-Taxi-Service-in-Shirdi" },
        { place: "/images/keyword/12.jpg", text: "Shirdi Airport Cab Service", link: "Shirdi-Airport-Cab-Service" },
        { place: "/images/keyword/13.jpg", text: "Online Cab Booking Shirdi", link: "Online-Cab-Booking-Shirdi" },
        { place: "/images/keyword/14.jpg", text: "Best Travel Agency in Shirdi", link: "Best-Travel-Agency-in-Shirdi" },
        { place: "/images/keyword/15.jpg", text: "Shirdi to Mumbai Airport Cab", link: "Shirdi-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/16.jpg", text: "Kopargaon to Shirdi Cab", link: "Kopargaon-to-Shirdi-Cab" },
        { place: "/images/keyword/17.jpg", text: "Innova on Rent in Shirdi", link: "Innova-on-Rent-in-Shirdi" },
        { place: "/images/keyword/18.jpg", text: "Shirdi Sightseeing Cab", link: "Shirdi-Sightseeing-Cab" },
        { place: "/images/keyword/19.jpg", text: "Shirdi Darshan Taxi", link: "Shirdi-Darshan-Taxi" },
        { place: "/images/keyword/20.jpg", text: "Bus on Hire in Shirdi", link: "Bus-on-Hire-in-Shirdi" },
        { place: "/images/keyword/21.jpg", text: "Best Sedan Cab in Shirdi", link: "Best-Sedan-Cab-in-Shirdi" },
        { place: "/images/keyword/22.jpg", text: "Ertiga Car Hire in Shirdi", link: "Ertiga-Car-Hire-in-Shirdi" },
        { place: "/images/keyword/23.jpg", text: "Innova Crysta on Rent in Shirdi", link: "Innova-Crysta-on-Rent-in-Shirdi" },
        { place: "/images/keyword/24.jpg", text: "Mini Bus on Rent in Shirdi", link: "Mini-Bus-on-Rent-in-Shirdi" },
        { place: "/images/keyword/25.jpg", text: "Tempo Traveller Hire in Shirdi", link: "Tempo-Traveller-Hire-in-Shirdi" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania Hire in Shirdi",
  "image": "https://www.saishirdicabs.com/assets/images/urbania-hire-in-shirdi.webp",
  "description":
    "Hire an Urbania in Shirdi with Sai Shirdi Cabs for comfortable, spacious, and reliable group travel. Our Force Urbania hire service is suitable for Sai Baba Darshan, Shirdi sightseeing, family trips, group tours, pilgrimage journeys, weddings, corporate travel, airport transfers, railway station transfers, one-way journeys, round trips, and outstation travel. Get a well-maintained Urbania with a professional driver, convenient pickup and drop locations, flexible travel options, affordable rental service, and easy booking assistance.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Shirdi Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.saishirdicabs.com/urbania-hire-in-shirdi"
  }
};






    return (
        <div>

<Helmet>
  <title>Urbania Hire in Shirdi | Force Urbania Rental & Booking | +91 7776814559</title>

  <meta
    name="description"
    content="Hire an Urbania in Shirdi with Sai Shirdi Cabs for group travel, Sai Baba Darshan, sightseeing, family trips, weddings, corporate travel and outstation journeys. Get a spacious Urbania with professional driver and easy booking."
  />

  <meta
    name="keywords"
    content="Urbania Hire in Shirdi, Urbania Rental in Shirdi, Force Urbania Hire Shirdi, Urbania on Rent Shirdi, Urbania Booking Shirdi, Urbania with Driver Shirdi, Urbania Cab Hire Shirdi, Urbania Taxi Hire Shirdi, Urbania for Outstation Shirdi, Urbania for Family Trip Shirdi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/123.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Sai Shirdi Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Sai Shirdi Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Shirdi Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917776814559" className="pc-call">+91 7776814559 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919579032227" className="pc-call">+91 9579032227 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91917776814559 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917776814559 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@saishirdicabs.com" className="pc-email">
                                            booking@saishirdicabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Sai Shirdi Cabs</strong><br />
                                            Sai Mandir Lene, Near Hotel Sai Kanhaiya,
                                            Shirdi,Tel - Rahata,Dist Ahilyanagar,
                                            Maharashtra, India - 423109




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default UrbaniaHireInShrirdi;